var map = {
	"./template.bet777": 1028,
	"./template.bet777.tsx": 1028,
	"./template.betprofessor": 1029,
	"./template.betprofessor.tsx": 1029,
	"./template.betroyale": 1030,
	"./template.betroyale.tsx": 1030,
	"./template.buffalobet": 1031,
	"./template.buffalobet.tsx": 1031,
	"./template.default": 652,
	"./template.default.tsx": 652,
	"./template.fiestabet": 1032,
	"./template.fiestabet.tsx": 1032,
	"./template.forsport": 1033,
	"./template.forsport.tsx": 1033,
	"./template.goldenrush": 1034,
	"./template.goldenrush.tsx": 1034,
	"./template.oldgill": 1035,
	"./template.oldgill.tsx": 1035,
	"./template.puntcity": 1036,
	"./template.puntcity.tsx": 1036,
	"./template.puntgenie": 1037,
	"./template.puntgenie.tsx": 1037,
	"./template.questbet": 1038,
	"./template.questbet.tsx": 1038,
	"./template.ts": 962,
	"./template.volcanobet": 1039,
	"./template.volcanobet.tsx": 1039,
	"./template.wellbet": 1040,
	"./template.wellbet.tsx": 1040
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2325;